{
  "plus": {
    "profile": {
      "preferences": "Asetukset"
    }
  }
}
